import React , { useState , useEffect } from 'react'
import Container from '@mui/material/Container';
import { useNavigate } from "react-router-dom"

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';

import UnpublishedIcon from '@mui/icons-material/Unpublished';
import Box from '@mui/material/Box';
// ventana de Dialogo
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
//
import { useStore } from './store/comercioStore' ;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SucursalesTodas() {
  const { asigna } = useStore();
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [comercios,setComercios] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openEstado, setOpenEstado] = React.useState(false);
  const [estado, setEstado] = React.useState(false);
  const [openMsgOk, setOpenMsgOk] = React.useState(false);
  const [openMsgError, setOpenMsgError] = React.useState(false);
  const [mensaje, setMensaje] = React.useState('');
  const [titulo, setTitulo] = React.useState('');

  const [id, setId] = React.useState(0);
  const [rz, setRz] = React.useState('');
  const [detalle, setDetalle] = React.useState('');

  const [centrosComerciales,setCentrosComerciales] = useState([]);

  const [sucursales,setSucursales] = useState([]);
  
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

 
  //const filteredData = comercios;
  const filteredData = sucursales.filter(item => item.nombredefantasia?.toLowerCase().includes(filter.toLowerCase())
  || item.razonsocial?.toLowerCase().includes(filter.toLowerCase()));
  
  const getSucursales = () => {
    const baseURL = process.env.REACT_APP_SERVER_PATH+'getSucursalesAll';
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
          (result) => {
              setSucursales(result);
              setLoading(false);
          },

      (error) => {

      }
    )
   }

   useEffect(() => {
    getSucursales(); 
},[])
  
  return (<>
       
    <Container component="main" maxWidth="lg">
     <h1>Comercios Adheridos</h1>
    
      {loading ? (
          <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : (  
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        < TableHead>
          <TableRow>
            <TableCell >Comercio</TableCell >
            <TableCell >Calle</TableCell >
            <TableCell >Nro</TableCell >
            <TableCell >Centro comercial</TableCell >
          </TableRow>
        </ TableHead>
        <TableBody>
        {filteredData.map((item) => (
            <TableRow
              key={item.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell >{item.nombredefantasia}</TableCell >
              <TableCell >{item.calle}</TableCell >
              <TableCell >{item.numero}</TableCell >
              <TableCell >{item.descripcion}</TableCell >
              </TableRow>
          ))}          
        </TableBody>
      </Table>
      </TableContainer>
       )}
    </Container>
   </> )
}

export default SucursalesTodas